import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import adaIcon from "src/assets/images/icon_ada.svg";
import atomIcon from "src/assets/images/icon_atom.svg";
import eosIcon from "src/assets/images/icon_eos.svg";
import ethIcon from "src/assets/images/icon_eth.svg";
import irisIcon from "src/assets/images/icon_iris.svg";
import image1 from "src/assets/images/wetez_reward_step1.png";
import image2 from "src/assets/images/wetez_reward_step2.png";
import image3 from "src/assets/images/wetez_reward_step3.png";

export const WalletEarnReward = () => {
  return (
    <Box
      height="700px"
      p="0 155px 0 115px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack>
        <Stack mt="50px" direction="row">
          <Typography
            mt="15px"
            variant="bold"
            fontSize="50px"
            color="white"
            alignSelf="flex-start"
            lineHeight="30px"
          >
            1
          </Typography>

          <Box width="312px" height="59px" ml="42px">
            <img width="100%" src={image1} alt="step1" />
          </Box>
        </Stack>

        <Box
          width="3px"
          height="38px"
          my="4px"
          ml="220px"
          sx={{
            backgroundColor: "#4096F7",
          }}
        />

        <Stack direction="row">
          <Typography
            mt="35px"
            variant="bold"
            fontSize="50px"
            color="white"
            alignSelf="flex-start"
            lineHeight="30px"
          >
            2
          </Typography>

          <Box width="312px" height="104px" ml="42px">
            <img width="100%" src={image2} alt="step2" />
          </Box>
        </Stack>

        <Box
          width="3px"
          height="38px"
          my="4px"
          ml="220px"
          sx={{
            backgroundColor: "#4096F7",
          }}
        />

        <Stack direction="row">
          <Typography
            mt="35px"
            variant="bold"
            fontSize="50px"
            color="white"
            alignSelf="flex-start"
            lineHeight="30px"
          >
            3
          </Typography>

          <Box width="312px" height="269px" ml="42px">
            <img width="100%" src={image3} alt="step3" />
          </Box>
        </Stack>
      </Stack>

      <Stack alignItems="flex-end">
        <Typography
          variant="bold"
          fontSize="40px"
          color="white"
          lineHeight="40px"
        >
          Earn your reward
        </Typography>

        <Typography
          color="secondary"
          fontSize="20px"
          lineHeight="20px"
          mt="45px"
        >
          Wetez wallet provides STAKE and
        </Typography>

        <Typography color="secondary" fontSize="20px" lineHeight="20px">
          DELEGATE to earn PoS consensus incentive.
        </Typography>
      </Stack>
    </Box>
  );
};
